import React from 'react'
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { usePostBrandMutation } from '../../../../store/api/barand_master';
import { useCreateItemTaxTemplateMutation } from '../../../../store/api/itemtaxapi';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import { usePageState } from "../../../../Hook/usePageState";

function Itemtax() {
  const navigate = useNavigate()
  // const [tab, settab] = useState(1)
  const [res, setRes] = useState(false)
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);
  const [postBrand] = usePostBrandMutation();
  const [status, setStatus] = useState(false)
 

   const pageStateDefault = {
          tab: 1,
          title:'',
          company:'',
          gst_treatment:'',
          gst_rate:'',
          selectedTaxAccounts:[{  tax_type: "",
    tax_rate: ""}],
      
        };
      
        const [pageState, setPageState] = usePageState(`Create Item Tax Template`, pageStateDefault);
      
      
        const { tab,title,company,gst_treatment,gst_rate,selectedTaxAccounts} = pageState;

  const [createItemTax, { isLoading, isError, isSucces }] = useCreateItemTaxTemplateMutation()
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPageState((prev) => ({
      ...prev,
      [name]: name === 'gst_rate' ? Number(value) : value,
    }));
  };


 const handleSubmit = async () => {
  const payload = {
    title: pageState.title,
    company: pageState.company,
    gst_treatment: pageState.gst_treatment,
    gst_rate: pageState.gst_rate,
    taxes: (selectedTaxAccounts || []).map((row) => ({
    ...row,
    tax_rate: row.tax_rate ? parseFloat(row.tax_rate) : 0, // ✅ convert to float
  })),
  };

  try {
    const response = await createItemTax(payload).unwrap();
    if (response) {
      setError("Item Tax Template created successfully!");
      setptype("Success");
      setShowError(true);
      setStatus(true);
      setTimeout(() => {
        navigate("/master/itemtax/item-tax-list");
      }, 3000);
    }
  } catch (error) {
    console.error("Error creating Item Tax Template:", error);

    let errorMessage = "Something went wrong. Please try again.";

    try {
      // ✅ Safely handle both frappe and network errors
      if (error?.data?._server_messages) {
        const parsedMessages = JSON.parse(error.data._server_messages);
        const firstMessageObj = JSON.parse(parsedMessages[0]);
        errorMessage = firstMessageObj.message || errorMessage;
      } else if (error?.data?.message) {
        errorMessage = error.data.message;
      } else if (error?.error) {
        errorMessage = error.error;
      }
    } catch (parseErr) {
      console.warn("Error parsing frappe message:", parseErr);
    }

    setError(errorMessage);
    setptype("Error");
    setShowError(true);
  }
};
 
  return (
    <>
      <FormLayoutTwo
        title="New Item Tax Template"
        breadcrumbs={[
          { label: "Item Tax Template" },
          { label: "Item Tax Template List ", url: "/master/itemtax/item-tax-list" }
        ]}
        status={'hide'}
        actionButtons={
          <>
            <Button
              className="custom-btn-bluecolor d-flex"
              iconName="BiCloudUpload"
              style={{ gap: '2px' }}
              iconSize={14}
            >
              Upload
            </Button>
            <Button
              className="createbtn d-flex"
              style={{ gap: '2px', height: '28px' }}
              iconName="GrCopy"
              iconSize={12}
            >
              Duplicate
            </Button>
            <Button
              className="custom-btn-00989"
              iconName="LuFilePlus2"
              style={{ gap: '2px', height: '28px' }}
              onClick={handleSubmit}
              iconSize={12}
            >save
            </Button>

            <Button
              to="/brand/create-brand"
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
          </>
        }
      >
        <div className="" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end ">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                  <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => {  setPageState({ ...pageState, tab: 1 }) }} href="#">
                    General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>
              <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                <span style={{ position: "relative", top: "-1px" }}>
  <GetIcon className="text-[#4B002B]" iconName="CgAttachment" size={12} />
</span>
<span className="fw-semibold" style={{ color: "#4B002B" }}>
  Attachments
</span> 
              </div>
            </div>
          </div>

            <div className=" " style={{ background: '' }}>
                    <div className="row">
                      <div className="col-12">
                        <div >
                           <Tab1  
                                                    
                                                     pageState={pageState}
                                            setPageState={setPageState}
                          handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                            onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                              selectedTaxAccounts={{
                            value: pageState.selectedTaxAccounts || [],
                            setValue: (val) =>
                              setPageState({
                                ...pageState,
                                selectedTaxAccounts: val,
                              }),
                          }}  />
                          
                        </div>
                      </div>
                    </div>
                  </div>        
         
        </div>
        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayoutTwo>
    </>
  )
}

export default Itemtax
